export const COOKIE_NAME = "app_session_id";
// Cap for the Director composer's creative prompt (persisted as the project's
// initialPrompt, threaded through jobs as userIntent). Shared so the composer
// UIs can show a counter at the same limit the server truncates at. See
// server/directorJobSchemas.ts for the truncation helper and history.
export const DIRECTOR_INITIAL_PROMPT_MAX_CHARS = 8000;
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';
